import React from 'react';
import _ from 'underscore';

import ExpandedScrollableTable from 'ui-library/scrollable/ExpandedScrollableTable';
import {ScrollableTableRow, TABLE_ROW_BODY_HEIGHT} from 'ui-library/scrollable/ScrollableTableConstants';

import {WorkflowTemplate} from '../WorkflowConstants';
import * as WorkflowTemplateActions from '../WorkflowTemplateActions';

interface WorkflowDashboardTemplateTableProps {
  workflowTemplates: Array<WorkflowTemplate>;
}

export default class WorkflowDashboardTemplateTable extends React.Component<WorkflowDashboardTemplateTableProps> {
  _handleOpenWorkflowTemplate = (row: ScrollableTableRow): void => {
    WorkflowTemplateActions.openWorkflowTemplateViewScreen(row.id);
  };

  _getRowContentHeight = (rowIndex: number): number => {
    if (this.props.workflowTemplates.length === 0) {
      return TABLE_ROW_BODY_HEIGHT;
    }
    const template = _.sortBy(this.props.workflowTemplates, 'name')[rowIndex];
    // with a 300px width, the cell is about 45 characters long.
    return Math.ceil(template.name.length / 45) * TABLE_ROW_BODY_HEIGHT;
  };

  override render(): JSX.Element {
    return (
      <ExpandedScrollableTable
        className="u-flex-grow"
        matchParentHeight={true}
        columns={[
          {
            accessorKey: 'name',
            header: 'Name',
            width: 300,
          },
          {
            accessorKey: 'prefix',
            header: 'Workflow ID Prefix',
            width: 300,
          },
          {
            accessorKey: 'versions',
            header: 'Versions',
            flexGrow: 1,
          },
        ]}
        onRowClick={this._handleOpenWorkflowTemplate}
        emptyTableText="No templates"
        getRowContentHeight={this._getRowContentHeight}
        rows={_.sortBy(this.props.workflowTemplates, 'name').map((workflowTemplate) => ({
          id: workflowTemplate.id,
          data: {
            name: workflowTemplate.name,
            prefix: workflowTemplate.prefix,
            versions: workflowTemplate.workflowTemplateVersions.length,
          },
          classNames: {
            name: 'workflowDashboardTemplateTable-cell',
            versions: 'workflowDashboardTemplateTable-cell',
          },
        }))}
        isCompact={false}
      />
    );
  }
}
